module.exports = __webpack_public_path__ + "media/tintedeyes-dvbbs.aa36f261.mp3";